module.exports = __webpack_public_path__ + "img/me.4d024d93.png";